import { firstValueFrom, Observable, Subject, takeUntil } from "rxjs";

export abstract class AbstractService {
  private readonly cancelSubjects: Record<string, Subject<void> | undefined> = {};

  protected async cancelPrevious<T>(key: string, source: Observable<T>): Promise<T | null> {
    const cancelSubject = (this.cancelSubjects[key] ??= new Subject<void>());
    cancelSubject.next();
    return await firstValueFrom(source.pipe(takeUntil(cancelSubject)), { defaultValue: null });
  }
}
